import { useEffect } from 'react';
import { useTextScramble } from './useTextScramble';

interface TextScrambleProps {
  text: string;
  duration?: number;
  delay?: number;
  flipSpeed?: number;
  className?: string;
  onComplete?: () => void;
  endless?: boolean; // Keep cycling forever until stopped
  reverseReveal?: boolean; // Reveal from right to left (for letters closer to dot)
}

export function TextScramble({
  text,
  duration = 1200,
  delay = 0,
  flipSpeed = 50,
  className = '',
  onComplete,
  endless = false,
  reverseReveal = false,
}: TextScrambleProps) {
  const { displayText, isComplete } = useTextScramble({
    text,
    duration,
    delay,
    flipSpeed,
    endless,
    reverseReveal,
  });

  useEffect(() => {
    if (isComplete && onComplete) {
      onComplete();
    }
  }, [isComplete, onComplete]);

  return (
    <span className={className} aria-label={text}>
      {displayText || '\u00A0'.repeat(text.length)}
    </span>
  );
}
